/* eslint-disable global-require */
import Cookies from 'js-cookie';
import LoginConstants from 'client/util/Constants/LoginConstants';
import axios from 'axios';

function hasAdminPath() {
  return !!window.location.hash.replace('#', '').replace(/^\/$/, '');
}

function setLocation(url) {
  window.location.href = url;
}

async function isLoggedIn() {
  const path = '/api/users/getSelf';
  // VITE_API_BASE_URL is set for using staging services from local AP
  if (process.env.NODE_ENV?.indexOf('dev') >= 0 && process.env.VITE_API_BASE_URL) {
    axios.defaults.baseURL = process.env.VITE_API_BASE_URL;
    axios.defaults.withCredentials = true;
  }

  try {
    const response = await axios.get(path);
    const responseURL = response?.request?.responseURL ?? '';
    return {
      status: response?.status ?? 500,
      isAdmin: responseURL.includes(path),
    };
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      isAdmin: null,
    };
  }
}

function storeRequestedPage() {
  const { hash } = window.location;

  if (hash && !hash.match('logout')) {
    window.sessionStorage.setItem(LoginConstants.redirectTo, `/${hash}`);
  }
}

// Figure out what to load since we have Login, User and Admin on the same domain.
// Step 1: Determine where the user wants to go.
// Step 2: Check if they need to login first.
const prevLoginType = Cookies.get(LoginConstants.clientTypeCookie);
if (hasAdminPath() || prevLoginType === LoginConstants.clientType.admin) {
  // User wants Admin Portal
  isLoggedIn().then(({ status, isAdmin }) => {
    // if we received an expected response
    if (status === 200 || (status >= 400 && status < 500)) {
      if (isAdmin) {
        // eslint-disable-next-line no-unused-expressions
        import('client/admin-portal');
      } else {
        storeRequestedPage();
        setLocation(LoginConstants.loginRoutes.admin);
      }
    // anything other than 200 or 4xx errors are unexpected, stop loading and display error page
    } else {
      // eslint-disable-next-line no-unused-expressions
      import('client/load-error');
    }
  });
} else {
  // User wants User Portal
  // TODO: User Auth check
  setLocation(LoginConstants.loginRoutes.user);
}
